import React, {useEffect, useState} from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import {FormInput} from "@/Components/Controls";
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, useForm} from '@inertiajs/inertia-react';
import "../../../sass/guest/add-address.scss";
import AddressValidationModal from "@/Pages/Organization/AddressValidationModal";
import AddressForm from "@/Pages/Organization/AddressForm";
import {useAddressForm, updateAddressFrom,  validationEffects}  from "@/Pages/Organization/AddressForm";

export default function AddSubOrganization(props) {
    const {data, setData, post, processing, errors} = useAddressForm({'organizationName':""});
    const [stateOptions, setStateOptions] = useState();
    const [validationModal, setValidationModal] = useState(false);
    const [validationObjects, setValidationObjects] = useState([]);
    const [validationOptions, setValidationOptions] = useState([]);
    const [save_address_value, setSaveAddress] = useState("0");
    const [organizationNameValue, setOrganizationNameValue] = useState("");

    useEffect(() => {
        axios.get(route('organization.add-address.states'))
            .then(res => setStateOptions(res.data));
    }, [])

    function updateAddressFromAutofill(autofillIndex) {
        let autofill = validationObjects[autofillIndex];
        updateAddressFrom(autofill, setData, setSaveAddress,{'organizationName':organizationNameValue});
    }

    function onOrganizationNameChange(name,value){
        setData(name, value);
        setSaveAddress('0');
        setOrganizationNameValue(value);
    }

    useEffect(() => {
        validationEffects(setValidationOptions, setValidationObjects, setValidationModal, errors);
    }, [errors])

    const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

    const submit = (e) => {
        e.preventDefault();
        post(route('create.sub-organization.store'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            {!hasDuplicates(validationOptions) &&
                <AddressValidationModal
                    validationModal={validationModal}
                    setValidationModal={setValidationModal}
                    validationOptions={validationOptions}
                    setAddress={updateAddressFromAutofill}
                />}
            <Head title={i18n.t("add-address.sub-organization-address")}/>
            <Head title={i18n.t("add-address.org-address")}/>
            <div className="outside-logo"></div>
            <div className="add-address sub-org">
                <form onSubmit={submit}>
                    <div className="title">
                        <h1 className="title-text">{i18n.t("add-address.sub-organization-address")}</h1>
                        <h6 className="abstract">{i18n.t("add-address.sub-organization-address-abstract")}</h6>
                    </div>
                    {false && <ValidationErrors errors={errors}/>}
                    <div className="row">
                        <FormInput
                            error={errors["organizationName"]}
                            name="organizationName"
                            autoComplete="no"
                            value={organizationNameValue}
                            label={i18n.t("add-address.organization-name")}
                            className="col-12"
                            dataTestid="add_sub_organization-input-organization_name"
                            onChange={onOrganizationNameChange}
                        />
                    </div>
                    <div className="row">
                        <p className="parent-organization"> Parent Organization: <b>{props.auth.current_organization.name}</b></p>
                    </div>

                    <AddressForm errors={errors} data={data} setData={setData} setSaveAddress={setSaveAddress} save_address_value={save_address_value} stateOptions={stateOptions} />

                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing}>
                            <span>{i18n.t("add-address.continue")}</span><i className="far fa-chevron-right"></i>
                        </Button>
                    </div>
                </form>
            </div>
            <div className="step">
                <span>{i18n.t("add-address.step")} 1 {i18n.t("add-address.of")} 5</span>
            </div>
        </Authenticated>
    );
}
